import reportService from "@/services/report";

export default {
  data: () => ({
    reportItem: [],
  }),
  methods: {
    async fetchTakenReport(params, companyId = null) {
      if (this.loading !== undefined) {
        this.loading = true;
      }

      try {
        const response = await reportService.getFoodOrdersOrdered(
          this.$store.state.restaurant.id,
          params
        );
        this.reportItem = response.data.filter((item) => {
          return item.company_id === companyId || companyId === null;
        });
      } catch (error) {
        console.error("Error fetching taken report:", error);
        this.reportItem = [];
      } finally {
        if (this.loading !== undefined) {
          this.loading = false;
        }
      }
    },
  },
  computed: {
    filters() {
      return this.$store.state.report.filters;
    },
  },
};
